export default __webpack_public_path__ + "static/media/mustard.6e462c01.svg";